import styled from "styled-components";
import { ACCENT_PRIMARY_LIGHTEST } from "@streeteasy/design-system/colors";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { H2, P } from "@streeteasy/design-system/typography";

export const CheckMark = styled(FontAwesomeIcon).attrs({
  color: "primary",
  fontSize: "32px",
  iconClass: "check"
})``;

export const CheckMarkContainer = styled.div`
  margin-bottom: 20px;
  text-align: center;
`;

export const SuccessMessageContainer = styled.div``;

export const Content = styled.div`
  padding: 70px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    height: 100vh;
    padding: 0 52px;

    & ${SuccessMessageContainer} {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const SuccessText = styled(P)`
  text-align: center;
`;

export const SuccessTextContainer = styled.div`
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  padding: 20px 30px;
`;

export const SuccessTitle = styled(H2)`
  margin-bottom: 20px;
  text-align: center;
`;
